<script setup>
import Icon from '@/components/Icon.vue';

const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  intro: { type: String, default: '' },
  cards: { type: Array, default: () => [] }, // [{ icon, title, body }]
});
</script>

<template>
  <div :id="props.id" class="mb-20 scroll-mt-32">
    <h2 class="text-3xl font-serif text-[#1c4848] font-medium tracking-tighter mb-6">
      {{ props.title }}
    </h2>
    <p v-if="props.intro" class="text-base text-[#1c4848]/60 font-normal leading-relaxed mb-8">
      {{ props.intro }}
    </p>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div
        v-for="(c, idx) in props.cards"
        :key="idx"
        class="p-6 rounded-2xl bg-white border border-[#1c4848]/5 shadow-[0_4px_20px_rgb(28,72,72,0.02)] hover:shadow-[0_8px_30px_rgb(28,72,72,0.06)] transition-all duration-300"
      >
        <div class="w-8 h-8 rounded-full bg-[#1c4848]/5 flex items-center justify-center mb-4">
          <Icon v-if="c.icon" :icon="c.icon" class="text-lg text-[#1c4848]" />
          <span v-else class="text-lg text-[#1c4848]">✦</span>
        </div>
        <h4 class="font-medium text-[#1c4848] mb-2 text-sm">{{ c.title }}</h4>
        <p class="text-sm text-[#1c4848]/50 font-normal leading-relaxed">{{ c.body }}</p>
      </div>
    </div>
  </div>
</template>

